import React from "react";
import logo from "client/lil_drug/client-logo.svg";
import svglogo from "client/lil_drug/ClientLogo";
import clientOnlyResources from ".";
import theme from "client/lil_drug/theme";
import TeamIcon from "@mui/icons-material/Business";
import ContactsIcon from "@mui/icons-material/Contacts";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderSpecialIcons from "@mui/icons-material/FolderSpecial";
import ProductCategoryIcon from "@mui/icons-material/Dns";
import BusinessCenter from '@mui/icons-material/BusinessCenter'
import Alarm from '@mui/icons-material/Alarm';

import DavFiles from "dav_files";
import retry from 'custom_components/retry'

import { 
  fullFeatureList,
  storeAttrOptions,
  storeGroupByOptions,
  itemAttrOptions,
  storeFilterOptions,
  itemGroupColumnOptions,
  runtimeItemGroupFilterOptions
} from 'client/lil_drug/hardcoded_features'


const appConfig = {
  CLIENT_NAME_LABEL: "Lil Drug",
  CLIENT_NAME: "lil_drug",
  CLIENT_LOGO: logo,
  APP_BAR_LOGO: svglogo,
  AUTH_SUPPLIER_SOURCES: [
    { id: "DST", name: "DST" },
    { id: "MS3", name: "MS3" },
    { id: "DIT", name: "DIT" },
  ],
  USER_ROLES: [
    { id: "lil_drug", name: "Lil Drug" },
    { id: "lil_drug_admin", name: "Lil Drug Admin" },
    { id: "site_admin", name: "Site Admin" },
  ],
  CLIENT_CUSTOM_ROUTES: [
    {
      path: "/files/lil_drug_admin",
      component: DavFiles,
      allowedRoles: ["lil_drug_admin", "site_admin"],
    },
    {
      path: "/files/lil_drug",
      component: DavFiles,
      allowedRoles: ["lil_drug", "lil_drug_admin", "site_admin"],
    },
  ],
  EXTRA_MENUS: {
    menuCustomer: [
     
      {
        to: `/lil_drug_director`,
        label: "Director",
        icon: <BusinessCenter />,
        featureTag: "director",
      },
      {
        to: `/lil_drug_regional`,
        label: "Regional",
        icon: <TeamIcon />,
        featureTag: "regional",
      },
      {
        to: `/lil_drug_broker`,
        label: "Broker",
        icon: <ContactsIcon />,
        featureTag: "broker",
      },
      {
        to: `/lil_drug_chain_priority`,
        label: "Chain Priority",
        icon: <Alarm />,
        featureTag: "broker",
      }
    ],
    menuItem: [
      {
        to: `/lil_drug_product_hierarchy`,
        label: "Product Hierarchy",
        icon: <ProductCategoryIcon />,
        featureTag: "product_hierarchy",
      },
    ],
    menuFiles: [
      {
        // side menu link for Lil Drug Admin File access
        to: "/files/lil_drug_admin",
        label: "Admin Files",
        icon: <FolderSpecialIcons />,
        allowedRoles: ["lil_drug_admin", "site_admin"],
      },
      {
        // side menu link for Lil Drug File Access
        to: `/files/lil_drug`,
        label: "Files",
        icon: <FolderSharedIcon />,
        allowedRoles: ["lil_drug", "lil_drug_admin", "site_admin"],
      },
    ],
    // 'extraMenu': {}
  },
  CUSTOM_PAGES: {
    master_chain: {
      list: null,
      // edit: null
      edit: React.lazy(() =>
        retry(() => import("./master_chain/MasterChainEdit"))
      ),
      // list: null,
    },
    master_distributor: {
      list: null,
      edit: null
      // edit: React.lazy(() =>
      //   retry(() => import("./master_distributor/MasterDistributorEdit"))
      // ),
      // list: null,
    },
    master_customers: {
      // list: null,
      // edit: null
      edit: React.lazy(() => retry(() => import("./master_customers/Edit"))),
      list: React.lazy(() => retry(() => import("./master_customers/List"))),
    },
    master_items: {
      // list: null,
      // edit: null,
      edit: React.lazy(() => retry(() => import("./master_items/Edit"))),
      list: React.lazy(() => retry(() => import("./master_items/List"))),
    },
  },
  DASHBOARD_CONFIG: {
    dimensions: {},
    sunburstHierarchies: {
      "Distributor/Warehouse": ["distributor_name", "warehouse_name"],
      "Product Hierarchy": [
        "product_hierarchy_level_1"
      ],
    },
  },
  DEPLOY_TARGET_TABS: [
    { id: "main_dashboard", name: "Main Dashboard" }, // default - main dashboard
    { id: "brand_id", name: "Items" }, // default - item level page
    {
      id: "distributor",
      name: "Distributors",
      dimension: "distributor_name",
      targetConfig: {
        resource_name: "lil_drug_distributor",
        name: "Distributor",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "warehouse_name@eq",
      },
    }, // default - chain page
    {
      id: "master_chain",
      name: "Chains",
      dimension: "lil_drug_chain",
      targetConfig: {
        resource_name: "master_chain",
        name: "Chain",
        column_defs: [{ id: 50 }, { primary_name: 350 }],
        filter_column: "lil_drug_chain@eq",
      },
    }, // default - chain page
    
    {
      id: "product_hierarchy",
      name: "Product Hierarchy",
      featureTag: "product_hierarchy",
      dimension: "product_hierarchy",
      targetConfig: {
        resource_name: "lil_drug_product_hierarchy",
        name: "Product Hierarchy",
        column_defs: [{ id: 50 }, { name_path: 350 }],
        filter_column: "product_hierarchy_name_path@eq",
      },
    },
    {
      id: "director_chain",
      name: "Chain Director",
      featureTag: "director",
      dimension: "director_chain",
      targetConfig: {
        resource_name: "lil_drug_director",
        name: "Chain Director",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "director_chain@eq",
      },
    },
    {
      id: "regional_chain",
      name: "Chain Regional",
      featureTag: "regional",
      dimension: "regional_chain",
      targetConfig: {
        resource_name: "lil_drug_regional",
        name: "Chain Regional",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "regional_chain@eq",
      },
    },
    {
      id: "broker_chain",
      name: "Chain Broker",
      featureTag: "broker",
      dimension: "broker_chain",
      targetConfig: {
        resource_name: "lil_drug_broker",
        name: "Chain Broker",
        column_defs: [{ id: 50 }, { name: 350 }],
        filter_column: "broker_chain@eq",
      },
    },
  ],
  CUSTOM_RESOURCES: clientOnlyResources,
  CLIENT_THEME: theme,
  BACKGROUND_IMAGE: "bg.jpg",
  featureList: fullFeatureList,
  routeOverrides: {},
  REPORTING_OPTIONS: {
    storeAttrOptions,
    storeGroupByOptions,
    itemAttrOptions,
    storeFilterOptions,
    itemGroupColumnOptions,
    runtimeItemGroupFilterOptions,
    reportAvailability: {
      "Period Comparison": true,
      "Period Comparison Store Level": true,
      "Fact Summary": true,
      "Void Report": false,  
      "Store Rows/Item Columns Pivot": true,
      "Store Group Rows/Item Columns Pivot": true,
      "Store Rows/Item Columns Pivot (No Item Groups)": true,
      "Item Group Summary": true,
      "ACV by Store Group And Period": true
    },
    calendarFormat: "445"
  }
};

export default appConfig;
